export default __webpack_public_path__ + "static/media/energy-asset-icon.0fa14059.svg";